import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface EnableFlagParams {
  flag: string;
}

const enable = (flagName: string) =>
  reactQueryPatch<boolean, EnableFlagParams>(
    internalApi.communities.onboardingFlags.update({ flag: flagName }),
    { flag: flagName },
  );

export const onboardingFlagsApi = {
  enable,
};
